import {base64DecodeUnicode} from "./utilities/base64";
import {initInputBody} from "./inputfile";
import {initInputMaskDate} from "./inputMaskDate";
import {initPhoneCountryFields} from "./phoneCountryField";
import {focusInputGroups} from "./checkInputGroups";

function loadRecaptchaHtml(formWrapper) {
    formWrapper.innerHTML = base64DecodeUnicode(formWrapper.dataset.html);

    const form = formWrapper.querySelector("form");
    if (!form) {
        return;
    }

    initInputMaskDate(formWrapper.querySelectorAll('input[type="date"],.js-inputMasketDate'));
    initInputBody(formWrapper.querySelectorAll('.fileBody'));
    initPhoneCountryFields(formWrapper.querySelectorAll("input[type=tel]"));
    focusInputGroups(formWrapper.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea'));

    if (formWrapper.querySelector(".contactform")) {
        formWrapper.querySelector(".contactform").style.opacity = 1;
    }

    form.addEventListener("submit", function (e) {
        e.preventDefault();
        grecaptcha.execute();
    });

    window.onRecaptchaSuccess = function (token) {
        const event = new CustomEvent("recaptcha:success", {
            detail: {token, form: form}
        });
        formWrapper.dispatchEvent(event);
        form.submit();
    };
}

export function initRecaptchaForms(wrapper = document) {
    const observer = new MutationObserver(function (mutationList, observer) {
        for (let mutation of mutationList) {
            let target = mutation.target;
            if (target) {
                loadRecaptchaHtml(target);
            }
        }
    });

    for (let form of wrapper.querySelectorAll('.js-RecaptchaForm')) {
        observer.observe(form, {
            attributes: true,
            childList: false,
            subtree: false
        });
    }
}